module.exports = __webpack_public_path__ + "img/vertical-logo-white.139e4bb5.svg";